import script from "./OnboardingView.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingView.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingView.vue?vue&type=style&index=0&id=0aa8657f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa8657f"]])

export default __exports__